import { useContext } from 'react';
import { WorkspaceFilePreviewContext } from '../Context';

export const useFilePreviewData = () => {
  const data = useContext(WorkspaceFilePreviewContext);

  return data;
};

export default useFilePreviewData;